
import { combineReducers }   from 'redux';
import { componentsReducer } from './componentsReducer';
import { modalReducer }      from './modalReducer';

const reducer = combineReducers({
  components: componentsReducer,
  modal:      modalReducer
})

export type reducerType = ReturnType<typeof reducer>;

export { reducer };
